import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowUpFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M7.61 15.619a2 2 0 0 0 2.94 0l3.45-3.62v13a2 2 0 1 0 4 0v-13l3.45 3.62a2 2 0 0 0 2.94 0 2.16 2.16 0 0 0 0-3l-6.86-7a2.2 2.2 0 0 0-3.06 0l-6.86 7a2.16 2.16 0 0 0 0 3"
    />
  </svg>
);
const ForwardRef = forwardRef(IconArrowUpFilledSVG);
ForwardRef.displayName = "IconArrowUpFilled";
export { ForwardRef as IconArrowUpFilled };
